import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { AccountTicketsEffects } from './+state/account-tickets.effects';
import { AccountTicketsNgrxFacade } from './account-tickets.facade';
import * as fromAccountTickets from './+state/account-tickets.reducer';
import { AccountTicketsService } from './services/account-tickets.service';
import { EffectsModule } from '@ngrx/effects';

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forFeature(
            fromAccountTickets.ACCOUNT_TICKETS_FEATURE_KEY,
            fromAccountTickets.accountTicketsReducer
        ),
        EffectsModule.forFeature([AccountTicketsEffects])
    ],
    providers: [AccountTicketsService, AccountTicketsNgrxFacade, AccountTicketsEffects]
})
export class AccountTicketsNgrxModule {}
